import RatingComponent from "../components/rating-component";
import {RenderPosition, render} from "../utils/render";

export default class RatingController {
  constructor({className, rating = 0, onClickHandler}) {
    this._className = className;
    this._rating = rating;
    this._onClickHandler = onClickHandler;
  }

  render(container) {
    const button = new RatingComponent({
      className: this._className,
      count: this._rating,
    });

    button.setClickHanlder(this._onClickHandler);

    render(container, button.getElement(), RenderPosition.BEFOREEND);
  }
}
